import { Box, Typography, Container } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { GENERAL__APP_UNDER_MAINTENANCE } from 'translations/constants';

const MaintenancePage = () => {
  const [t] = useTranslation();
  return (
    <Container maxWidth="sm" sx={{ textAlign: 'center', pt: 10 }}>
      <Box>
        <Typography variant="h3" gutterBottom>
          🚧 Maintenance Mode
        </Typography>
        <Typography variant="body1" color="textSecondary">
          {t(GENERAL__APP_UNDER_MAINTENANCE)}
        </Typography>
      </Box>
    </Container>
  );
};

export default MaintenancePage;
